import {Component} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {ButtonProminence} from "../../buttons/button/button";
import {Page} from "../../orchestration/page";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";

@Component({
    selector: "woa-age-verification-page",
    templateUrl: "./age-verification-page.component.html",
    providers: [{provide: Page, useExisting: AgeVerificationPageComponent}]
})
export class AgeVerificationPageComponent extends Page {
    ButtonProminence = ButtonProminence;

    constructor(public navigationService: NavigationService,
                public orderingContextModel: OrderingContextModel) {
        super();
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-info/age-verification-page/age-verification-page.component.ts